import gql from 'graphql-tag';

import DAILY_DEBRIEF_FRAGMENT from './DAILY_DEBRIEF_FRAGMENT';

export const GET_SERVICE_RUNS_DAILY_DEBRIEF = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: ServiceRunPageFilter
	) {
		getServiceRuns(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...serviceRunDailyDebrief
			}
			count
		}
	}
	${DAILY_DEBRIEF_FRAGMENT}
`;

export default GET_SERVICE_RUNS_DAILY_DEBRIEF;
